export function dayMode(date = new Date()) {
  const hour = date.getHours();
  return hour < 12 ? 'morning' : hour >= 19 ? 'evening' : 'day';
}

export function greeting(mode: ReturnType<typeof dayMode>) {
  if (mode === 'morning') return 'Доброе утро. Ресурс восстановлен';
  if (mode === 'evening') return 'Вечер. День прожит';
  return 'Пространство этого дня';
}

export function compactTime(iso: string) {
  return new Intl.DateTimeFormat('ru', { hour: '2-digit', minute: '2-digit' }).format(new Date(iso));
}

